/* globals gtag */

import React, { useCallback, useMemo } from "react"
import { useDispatch, useSelector } from "react-redux"
import { SetShowFilters } from "../../state/actions/index"
import "./FiltersButton.css"
import Utils from "../../utils/Utils"

const FiltersButton = () => {
  const activeFilters = useSelector((state) => state.activeFilters)
  const isMobile = useSelector((state) => state.isMobile)
  const accentColor = useSelector((state) => state.config.accentColor)
  // const filters = useSelector(state => state.filters);
  const shopId = useSelector((state) => state.config.shopId)
  const baseUrl = useSelector((state) => state.config.baseUrl)
  const showFilters = useSelector((state) => state.showFilters)
  const placeholders = useSelector((state) => state.config.placeholders)
  const display = useSelector((state) => state.config.display)
  const isAutocompleteOpen = useSelector((state) => state.isAutocompleteOpen)
  const ga4 = useSelector((state) => state.config.ga4)
  const dispatch = useDispatch()

  var iconStyle = useMemo(() => {
    return { backgroundColor: accentColor }
  }, [accentColor])
  var borderStyle = useMemo(() => {
    return { border: "solid 1px " + accentColor }
  }, [accentColor])

  const isCompactDisplay = useMemo(
    () => !isMobile && (display === "half-screen" || display === "windowed"),
    [display, isMobile]
  )
  const label = useCallback(
    (activeFilters) => {
      if (isCompactDisplay)
        return showFilters ? placeholders.hideFilters : placeholders.showFilters
      else
        return activeFilters.length > 0
          ? placeholders.activeFilters
          : placeholders.filterBy
    },
    [isCompactDisplay, showFilters, placeholders]
  )

  const clickFilter = useCallback(() => {
    if (isCompactDisplay) {
      Utils.sendAnalyticsObject(
        baseUrl,
        shopId,
        !showFilters ? "as_open_filters" : "as_close_filters"
      )
      if (!!ga4?.isActive) {
        if (typeof window.dataLayer !== "undefined" && !!window.dataLayer) {
          window.dataLayer.push({
            event: !showFilters ? "as_open_filters" : "as_close_filters",
            data: {},
          })
        } else if (typeof gtag !== "undefined") {
          gtag(
            "event",
            !showFilters ? "as_open_filters" : "as_close_filters",
            {}
          )
        }
      }
      dispatch(SetShowFilters(!showFilters))
    } else {
      Utils.sendAnalyticsObject(baseUrl, shopId, "as_open_filters")
      if (!!ga4?.isActive) {
        if (typeof window.dataLayer !== "undefined" && !!window.dataLayer) {
          window.dataLayer.push({
            event: "as_open_filters",
            data: {},
          })
        } else if (typeof gtag !== "undefined") {
          gtag("event", "as_open_filters", {})
        }
      }
      dispatch(SetShowFilters(true))
    }
  }, [dispatch, isCompactDisplay, showFilters, baseUrl, shopId])

  return !isAutocompleteOpen ? (
    <div
      style={isMobile ? borderStyle : {zIndex: 1}}
      className={
        "filters-button" +
        (showFilters ? " show-filters" : "") +
        (activeFilters.length > 0 ? " active" : "")
      }
      onClick={clickFilter}
      role="button"
      tabIndex={0}
    >
      {isCompactDisplay ? (
        <div /* style={iconStyle}  */ className="icon" />
      ) : null}
      <div className="label"> {label(activeFilters)} </div>
      {activeFilters.length > 0 && !isCompactDisplay ? (
        <div
          style={iconStyle}
          className="icon"
          onClick={() => Utils.closeLayer(display, isMobile)}
        ></div>
      ) : null}
    </div>
  ) : null
}

export default FiltersButton
